import React from 'react'
import {Button, Popover} from '@material-ui/core'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'
import PopSelect from './PopSelect'
import PopSelectOption from './PopSelectOption'
import ActionStepRow from './ActionStepRow'
import './ActionSteps.scss'
import LoadingIndicator from '../LoadingIcon'
import _ from 'lodash'

const RootClass = 'mod-action-steps'
const ActionSteps = ({steps, onChange}) => {
  const {groupActions, getGroupActions} = React.useContext(ReservationConfigurationContext)
  const {group_id} = useParams()
  const refAddAction = React.useRef(null)
  const [openSelect, setOpenSelect] = React.useState(false)

  const handleClickAddAction = e => {
    setOpenSelect(true)
    if (groupActions.data.length === 0) {
      getGroupActions({
        group_id: group_id,
        params: {is_returnable: true, type: 'ReservationAction'},
      })
    }
  }

  const handleSelectOption = (e, data) => {
    // create
    const _steps = [
      ...steps,
      {
        action_id: data.id,
        blocked_by_reservation_action_ids: data.blocked_by_reservation_action_ids || [],
        return_field_data: null,
      },
    ]
    onChange(e, _steps)
    setOpenSelect(false)
  }

  const handleClosePopover = e => {
    setOpenSelect(false)
  }

  const handleChangeField = (e, action_id, field) => {
    const _steps = _.cloneDeep(steps)
    const step = _steps.find(s => s.action_id === action_id)
    if (step) {
      step.return_field_data = {id: field.id, type: field.type}
      onChange(e, _steps)
    }
  }

  const handleClickRemove = (e, index) => {
    const _steps = [...steps]
    _steps.splice(index, 1)
    onChange(e, _steps)
  }

  // use Effect
  React.useEffect(() => {
    if (steps.length !== 0 && groupActions.data.length === 0) {
      getGroupActions({
        group_id: group_id,
        params: {is_returnable: true, type: 'ReservationAction'},
      })
    }
  }, [steps, group_id, groupActions.data.length, getGroupActions])

  const filteredGroupActions = React.useMemo(
    () => groupActions.data.filter(a => !a.is_system && !steps.find(s => s.action_id === a.id)),
    [groupActions, steps]
  )

  return (
    <div className={`c-res-mod`}>
      {groupActions.isLoading && steps.length > 0 && <LoadingIndicator style={{width: 200}} />}

      {!groupActions.isLoading && (
        <>
          {/* row here */}
          <div className={`${RootClass}__list`}>
            {steps.map((s, i) => (
              <ActionStepRow
                key={i}
                data={s}
                actions={groupActions.data}
                onChangeField={handleChangeField}
                onClickDelete={e => handleClickRemove(e, i)}
              />
            ))}
          </div>
        </>
      )}

      <Button
        ref={refAddAction}
        onClick={handleClickAddAction}
        className={`reservation-configuration__button ${groupActions.isLoading && 'ap-disabled'}`}
        style={{marginTop: 8}}
      >
        Add Action
      </Button>
      <PopSelect anchorEl={refAddAction.current} open={openSelect} onClose={handleClosePopover}>
        {groupActions.isLoading && <LoadingIndicator style={{width: '100%'}} />}
        {!groupActions.isLoading && filteredGroupActions.length === 0 && (
          <div
            className="c-res-mod ap-typography ap-typography-sm ap-typography--gray"
            style={{padding: 8}}
          >
            No results found
          </div>
        )}
        {filteredGroupActions.map((a, i) => (
          <PopSelectOption key={i} onClick={e => handleSelectOption(e, a)}>
            {a.name}
          </PopSelectOption>
        ))}
      </PopSelect>
    </div>
  )
}

export default ActionSteps
